// Edge-compatible replacement for Apollo hooks
import { useQuery, useMutation, useLazyQuery } from "@/lib/graphql-client";
import {
  GET_BUSINESS_VIA_IDENTIFIER,
  GET_SALON_FOR_BOOKING,
  GET_FAQS,
  SEARCH_CLIENT,
  CREATE_CLIENT,
  CREATE_APPOINTMENT,
  GET_APPOINTMENT_SUMMARY,
  SALON_AVAILABILITY,
  APPOINTMENT_PREVIEW,
  REDEEM_VOUCHER_CODE,
  VALIDATE_PHONE_NUMBER,
} from "../queries/booking-edge";

// Business and Salon queries
export const useGetBusinessViaIdentifier = (bookingUrlIdentifier: string) => {
  return useQuery(
    GET_BUSINESS_VIA_IDENTIFIER,
    { bookingUrlIdentifier },
    { skip: !bookingUrlIdentifier }
  );
};

export const useGetSalonForBooking = (salonId: string | null) => {
  return useQuery(GET_SALON_FOR_BOOKING, { salonId }, { skip: !salonId });
};

export const useGetFaqs = (salonId: string | null) => {
  return useQuery(GET_FAQS, { salonId }, { skip: !salonId });
};

// Client queries and mutations
export const useSearchClient = ({
  salonId,
  phone,
  countryCode,
}: {
  salonId: string;
  phone?: string;
  countryCode?: string;
}) => {
  return useQuery(
    SEARCH_CLIENT,
    { salonId, phone, countryCode },
    { skip: !salonId || !phone || !countryCode }
  );
};

// Lazy query for search client
export const useLazySearchClient = () => {
  return useLazyQuery(SEARCH_CLIENT);
};

export const useCreateClient = () => {
  return useMutation(CREATE_CLIENT);
};

export const useRedeemVoucher = () => {
  return useMutation(REDEEM_VOUCHER_CODE);
};

// Appointment mutations
export const useCreateAppointment = () => {
  return useMutation(CREATE_APPOINTMENT);
};

// Lazy query for appointment summary
export const useLazyGetAppointmentSummary = () => {
  return useLazyQuery(GET_APPOINTMENT_SUMMARY);
};

// Availability query
export const useLazySalonAvailability = () => {
  return useLazyQuery(SALON_AVAILABILITY);
};

// Appointment preview mutation
export const useAppointmentPreview = () => {
  return useMutation(APPOINTMENT_PREVIEW);
};

// Phone validation query
export const useLazyValidatePhoneNumber = () => {
  return useLazyQuery(VALIDATE_PHONE_NUMBER);
};
